/**
 * The default config object
 */
export default {
	cart: {
		endpoints: {},
		actions: {
			add: {
				success: {
					desktop: ['update_cart_header', 'cart_preview_drawer'],
					mobile: ['redirect_cart'],
				},
				error: {},
			},
			update: {
				success: {
					desktop: ['update_cart_header', 'reload_container'],
					mobile: ['update_cart_header', 'reload_container'],
				},
				error: {},
			},
			modify: {
				success: {
					desktop: ['redirect_cart'],
					mobile: ['redirect_cart'],
				},
				error: {},
			},
			'delete': {
				success: {
					desktop: ['update_cart_header', 'reload_container'],
					mobile: ['update_cart_header', 'reload_container'],
				},
				error: {},
			},
			addCoupon: {
				success: {
					desktop: ['toast_notification', 'reload_container'],
					mobile: ['toast_notification', 'reload_container'],
				},
				error: {},
			},
			deleteCoupon: {
				success: {
					desktop: ['reload_container'],
					mobile: ['reload_container'],
				},
				error: {},
			},
		},
		count_items: 0,
		total_amount: 0,
	},
	catalog: {
		products_per_row: {
			desktop: 4,
			mobile: 2,
		},
	},
	comparer: {
		endpoints: {},
		actions: {
			add: {
				success: {
					desktop: ['update_comparer_header', 'toast_notification', 'comparer_preview_drawer'],
					mobile: ['update_comparer_header', 'toast_notification', 'comparer_preview_drawer'],
				},
				error: {},
			},
			'delete': {
				success: {
					desktop: ['update_comparer_header', 'toast_notification', 'comparer_close_empty_preview_drawer'],
					mobile: ['update_comparer_header', 'toast_notification', 'comparer_close_empty_preview_drawer'],
				},
				error: {},
			},
		},
		toggle_action: {
			icon_selector: 'svg.icon',
			icon_saved_class: 'icon-check-square',
			icon_default_class: 'icon-square',
		},
		count_items: 0,
	},
	counter: {
		actions: {
			ended: {
				success: {
					desktop: ['close_modal'],
					mobile: ['close_modal'],
				},
				error: {},
			},
		},
	},
	cookie: {
		path: '/',
		domain: location.hostname,
		secure: location.protocol === 'https:',
		/** @type {'none'|'None'|'lax'|'Lax'|'strict'|'Strict'} */
		samesite: 'lax',
		visitor: '_uvc',
	},
	customer: {
		/** @type {number} */
		id: null,
		/** @type {string} */
		name: null,
	},
	env: {
		geo_cookie_name: null,
		language: {
			iso_code: 'en',
			lang_locale: 'en_US',
			canonical_locale: 'en-US',
		},
		timezone: undefined,
		revision: '0',
		js_revision: '0',
		sw_revision: '0',
		mobile: false,
	},
	event: {
		endpoints: {
			push: '/event',
		},
	},
	facebook: {
		enabled: false,
		app_id: '',
		sdk_version: '',
		connect_enabled: false,
		connect_url: '',
		connect_permissions: '',
	},
	inventory: {
		endpoints: {},
		actions: {
			add: {
				success: {
					desktop: ['toast_notification'],
					mobile: ['toast_notification'],
				},
				error: {},
			},
			'delete': {
				success: {
					desktop: ['toast_notification'],
					mobile: ['toast_notification'],
				},
				error: {},
			},
		},
	},
	page: {
		language_urls: null,
	},
	shop: {
		ajax_navigation: {
			enabled: false,
			module_id: '',
		},
		scroll_restoration: 'auto',
	},
	routes: {},
	rules: {
		overlays: {
			navigation: {
				click_selector: 'a[href]:not([href=""], [href^="#"], [href^="javascript:"], [rel~="external"], [target], [data-cart-add], [data-cart-update], [data-cart-delete], [data-cart-delete-coupon])',
				submit_selector: 'form:not([rel~="external"], [data-ajax-submit], [target], [data-cart-add], [data-cart-modify], [data-cart-add-coupon])',
			},
		},
	},
	theme: {
		id: 'base-theme',
		version: 4,
	},
	ui: {
		selector: 'body',
		icon_prefix: 'icon-',
		lang_selector: '#mp-json-translations',
		form_js_validation_selector: '[data-js-validation]',
		form_row_selector: '.form__row',
		form_group_selector: '.form__group',
		form_option_group_selector: '.form__option-group',
		form_validator_top_level_class: 'alert alert--error alert--dismissible',
		form_validator_container_selector: '.form__option-group, .form__group, .form__row',
		form_row_error_selector: '.form__row--invalid',
		form_row_invalid_class: 'form__row--invalid',
		form_row_invalid_feedback_class: 'form__invalid--feedback',
		scroll_top_arrow_selector: '#scroll-to-top-arrow',
		alert: {
			selector: '.alert',
			dismissible_selector: '.alert--dismissible',
			container_dismissible_selector: '.container--dismissible',
			markup: '<div class="alert alert--error alert--dismissible" role="alert"><div class="alert__message">%message%</div></div>',
		},
		dialog: {
			wrapper: {
				'class': 'modal-ask',
			},
			body: {
				'class': 'modal-body-centered-y',
			},
			footer: {
				type: 'div',
				attributes: {
					'class': 'form__buttons',
				},
			},
			alert: {
				default_buttons: {
					ok: {
						type: 'button',
						attributes: {
							type: 'button',
							'class': 'btn btn-primary',
							// 'data-bs-dismiss': 'modal',
						},
						text: void 0,
					},
				},
			},
			confirm: {
				default_title: null,
				default_content: null,
				default_buttons: {
					ok: {
						type: 'button',
						attributes: {
							type: 'button',
							'class': 'btn btn-primary',
							// 'data-bs-dismiss': 'modal',
						},
						text: void 0,
					},
					cancel: {
						type: 'button',
						attributes: {
							href: 'button',
							'class': 'btn btn-secondary',
							// 'data-bs-dismiss': 'modal',
						},
						text: void 0,
					},
				},
			},
		},
		focustrap: {
			// TinyMCE and Moxman are excluded by default
			excluded_elements: '.tox-tinymce, .tox-tinymce-aux, .moxman-window, .tam-assetmanager-root' +
				// Select2 is excluded by default
				', .select2-container' +
				// The litepicker plugin is excluded by default
				', .litepicker' +
				// By specific class
				', .ignore-focustrap',
		},
		toast: {
			container_class: 'toast-container',
			container_position_class: 'toast-container--%axis%-%position%',
			toast_class: 'toast',
			toast_format_class: 'toast--%format%',
			wrapper_no_title_class: 'toast__wrapper',
			wrapper_title_class: 'toast__header',
			title_class: 'toast__title',
			body_class: 'toast__body',
			icon_container_class: 'toast__icon',
			icon_template: '<svg class="icon icon--{type}"><use xlink:href="#icon-{icon}"/></svg>',
			/** @type {import('../modules/components/toast').MpToastOptions} */
			options: {
				positionX: 'right',
				positionY: 'top',
				delay: 5000,
				autohideError: false,
			},
		},
	},
	uploader: {
		ajax_name: 'temp_file',
	},
	wishlist: {
		endpoints: {},
		actions: {
			add: {
				success: {
					desktop: ['update_wishlist_header', 'toast_notification'],
					mobile: ['update_wishlist_header', 'toast_notification'],
				},
				error: {},
			},
			'delete': {
				success: {
					desktop: ['update_wishlist_header', 'toast_notification'],
					mobile: ['update_wishlist_header', 'toast_notification'],
				},
				error: {},
			},
		},
		toggle_action: {
			icon_selector: 'svg.icon',
			icon_saved_class: 'icon-heart-full',
			icon_default_class: 'icon-heart-empty',
		},
		access_permission: 'any',
		count_items: 0,
	},
};
